module.exports = __webpack_public_path__ + "img/border2.482a4a5.png";